<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="shuaixn()">刷新</el-button>
      <el-button type="warning">待还总金额 {{to_be_returned}} 已还总金额 {{already_repaid}}总计{{total_amount}}</el-button>
    </div>
     <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="会员信息">
            <el-input v-model="searchForm.search" placeholder="请输入昵称|手机号|ID"></el-input>
          </el-form-item>
          <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
              placeholder="请输入订单号"></el-input></el-form-item>
          <el-form-item label="配送方式">
            <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="起始时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
              @click="onSubmit">查询</el-button></el-form-item>
          <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
        </el-form>
      </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
          v-loading="loading">
          <el-table-column prop="order_no" label="订单信息" width="300" height="200">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <!-- <span class="state-text" :class="{ 'state-text-red': scope.row.order_source != 10 }">
                  {{ scope.row.order_source_text }} </span> -->
                <!-- <div class="c_main">订单号：{{ scope.row.order_no }}</div> -->
                <!-- <span> 下单时间：{{ scope.row.create_time }} </span> -->
                <!--是否取消申请中-->
                <span class="pl16" v-if="scope.row.order_status == 21"><el-tag effect="dark"
                    size="mini">取消申请中</el-tag></span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                  <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <!-- <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{ item.refund.status.text }}
                    </div> -->
                  </div>
                  <!-- <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">数量: x{{ item.total_num }}</div>
                  </div> -->
                </div>
              </template>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column> -->
          <el-table-column prop="yushou" label="租赁开始时间" width="90">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.create_time1 }}
            </template>

          </el-table-column>
          <el-table-column prop="yushou" label="总租期">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>1/12</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="租金">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div>{{scope.row.order_bill[0].price }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="已扣金额">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ yihuanzujin }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="is_pay_status" label="支付状态">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <div>{{scope.row.order_bill[0].is_pay_status }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="支付时间" width="90">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{scope.row.order_bill[0].create_time }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="本期还租时间" width="90">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.zhuande }}</div>
            </template>
          </el-table-column>
           <el-table-column prop="yushou" label="姓名">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.username }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="违约天数">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ xiaoyu }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="订单类型">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <div style="color:#DD1144">{{ scope.row.leixing }}</div>
              </template>
          </el-table-column>

          <el-table-column prop="remarks_risk" label="备注">
            <template slot-scope="scope">
              <div>{{ scope.row.remarks_risk }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="" label="买家" width="210">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.user">
              <div>姓名：{{ scope.row.user.username }}</div>
              <div>昵称：{{ scope.row.user.nickName }}</div>
              <div class="gray9">ID：({{ scope.row.user.user_id }})</div>
              <div>身份证号：{{ scope.row.user.usernum }}</div>
              <div>手机号：{{ scope.row.user.mobile }}</div>
              <div>订单号：{{ scope.row.order_no }}</div>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="anniu">
                <el-button @click="addClick(scope.row)" type="info" size="small"
                  v-auth="'/order/order/detail'">订单详情</el-button>
              </div>
              <div class="anniu">
                <el-button @click="gohuankuan(scope.row)" type="primary" size="small">还款详情</el-button>
              </div>
              <div class="anniu">
                <el-button @click="gofengkong(scope.row)" type="primary" size="small">备注</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 风控备注 -->
      <el-dialog title="备注" :visible.sync="dialogVisible5" width="60%" :before-close="handleClose5">
        <div style="margin:25px 0">
          <el-input v-model="remarksText1" placeholder="请输入"></el-input> <br>
        </div>
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </el-dialog>

      <!-- 弹窗 -->
      <el-dialog title="还款详情" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
          <el-table-column property="bill_id" label="ID"></el-table-column>
          <el-table-column property="current_period" label="期数"></el-table-column>
          <el-table-column property="price" label="应还款金额"></el-table-column>
          <el-table-column label="还款时间">
            <template slot-scope="scope">
            <span style="margin-left: 10px" >{{scope.row.repayment_date|formatDate}}</span>
          </template>
          </el-table-column>

          <el-table-column label="是否已经还">
            <template slot-scope="scope">
              <template v-if="scope.row.is_pay_status == 0">
                <span style="margin-left: 10px" >未还</span>
              </template>
              <template v-else-if="scope.row.is_pay_status == 1">
                <span style="margin-left: 10px" >已还</span>
              </template>
              <template v-else-if="scope.row.is_pay_status == 2">
                <span style="margin-left: 10px" >逾期</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog='closeLogistics'> </Logistics>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
import { timeFormat } from "@/utils/timeFormat"
import FengkongApi from '@/api/fengkong.js';
import Logistics from '@/components/logistics/viewLogistics.vue'
import qs from 'qs';
export default {
  name: 'Login',
  components: {
    Logistics
  },
  data() {
    return {
      total_amount:"",
      to_be_returned:"",
      already_repaid:"",
      gridData:"",
      dialogTableVisible:false,
      //备注
      dialogVisible5: false,
      //类型
      leixing: '',
      //违约天数
      xiaoyu: '',
      //还租时间
      zhuande: '',
      zhifushijian: '',
      zhifuzhuangtai: '',
      yihuanzujin: '',
      diyizujin: '',
      yuqijine: '',
      // 时间格式化
      time: '',
      // 十位数 时间戳
      timeTemp: '',
      // 十三位数 时间戳
      timesTemp: '',
      zujin: "",
      shop_url: "",
      htdata: "",
      // 签署id
      folwid: '',
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: '',
        order_no: '',
        style_id: '',
        create_time: '',
        total_price: '',
        price: '',
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
     
      total_price: '',
      peice: '',


      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0
      },
      isLogistics: false,
      logisticsData: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
     shuaixn(){
      this.loading = true;
      this.getData();
    },
    gojiedong(row) {
      this.$confirm('确定要解冻?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.ysunfreeze(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*押金转租金*/
    goyajin(row) {
      this.order_id = row.order_id;
      this.dialogVisible3 = true;
    },
    /*删除订单*/
    godelete(row) {
      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.delete(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //确定订单
    goque(row) {
      console.log("======", row.user.user_id);
      this.$confirm('确定要收获订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
          user_id: row.user_id,
        }
        OrderApi.receipt(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '确认成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    /*弹窗确定*/
    queding() {
      console.log(this.shneheList);
      if (this.shneheList.length <= 0) {
        this.$message({
          message: '请选择归还期数',
          type: 'error'
        });
        return;
      }
      OrderApi.toExamine({
        billid: this.shneheList
      }, true).then(data => {
        this.dialogVisible = false;
        console.log(data, "成功");
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*风控备注弹窗确定*/
    queding5() {
      let Params = {
        order_id: this.order_id,
        remarksType: 2,
        remarksText: this.remarksText1
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          this.dialogVisible5 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /* 还款详情 */
    gohuankuan(row){
      this.dialogTableVisible = true;
      let Params = {
        order_id: row.order_id
      }
      OrderApi.zuqi(Params, true)
        .then(res => {
          console.log("成功", res);
          this.gridData = res.data.billList
        })
        .catch(error => { });
    },
    /*风控备注*/
    gofengkong(row) {
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
    },
    handleClose5() {
      this.dialogVisible5 = false;
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    async getData() {
      let self = this;
      let resp = await AuthApi.userList(Params, true);
      let datainfo = resp.data.list.data;
      for (let item of datainfo) {
        if (item.role_id == 4) {
          self.searchForm.tuiguang_id = item.shop_user_id;
        } else {
          self.searchForm.tuiguang_id = "";
        }
      }
      OrderApi.orderlist2(Params, true)

        .then(res => {
          self.loading = false;
          let list = [];
          //已还
          self.already_repaid=res.data.statistics.already_repaid
          //待归还
           self.to_be_returned=res.data.statistics.to_be_returned
           //总计
          self.total_amount=res.data.statistics.total_amount
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let total = 0
            let total2 = 0
            let qishu = 0
            let zhende = ''
            let suanfa = 0
            let xiaoyu = ''
            let leixing = ''
            
            for (let i = 0; i < item.order_bill.length; i++) {
              console.log(item,"item")
              
              let hah = item.order_bill[i]
              // console.log("******************************",hah)
              if(hah.current_period==1){
                if(hah.is_pay_status==0){
                  hah.is_pay_status='未支付'
                }else if( hah.is_pay_status==1){
                     hah.is_pay_status='已支付'
                }else{
                   hah.is_pay_status='逾期'
                }
                self.is_pay_status= hah.is_pay_status
                item.is_pay_status = hah.is_pay_status
                // console.log("********************************123",self.is_pay_status)
              }
              
              var qian = hah.price
              var qian1 = parseFloat(qian)
              var yuqi = hah.is_pay_status
              //租金
              var diyi = hah.price
              this.diyizujin = diyi
              //还租时间
              var huanzushijian = hah.repayment_date
              let date = new Date(huanzushijian * 1000);
              //时间戳为10位需*1000，时间戳为13位的话不需乘1000
              let y = date.getFullYear();
              let MM = date.getMonth() + 1;
              MM = MM < 10 ? ('0' + MM) : MM; //月补0
              let d = date.getDate();
              d = d < 10 ? ('0' + d) : d; //天补0
              let h = date.getHours();
              h = h < 10 ? ('0' + h) : h; //小时补0
              let m = date.getMinutes();
              m = m < 10 ? ('0' + m) : m; //分钟补0
              let s = date.getSeconds();
              s = s < 10 ? ('0' + s) : s; //秒补0
              var bbbb = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
              item.zhuande = bbbb
              //当前时间
              let TheEnglishTime = new Date()
              this.time = timeFormat(TheEnglishTime); // 时间格式化  y-m-d h:m:s 
              this.timeTemp = parseInt(TheEnglishTime.getTime() / 1000); // 秒  
              this.timesTemp = TheEnglishTime.getTime(); // 毫秒 
              suanfa = this.timeTemp - huanzushijian
              if (suanfa < 0) {
                xiaoyu = 0
                this.xiaoyu = xiaoyu
              } else if (suanfa > 0) {
                var xiaoyu = suanfa - 12 * 24 * 60 * 60
              }
              if (yuqi == 1) {

              } else {
                qian1 = 0
              }
            }
            this.zhifuzhuangtai = zhende
            if (yuqi == 2) {
              leixing = '已逾期'
            } else {
              leixing = '正常'
            }
            item.leixing = leixing
            this.yihuanzujin = qian1
            var yuqijine = total
            var yihuanjine = total2
            //总租金
            var price = item.total_price
            this.total_price = price

            //支付时间
            this.zhifushijian = item.update_time


            var TheEnglishTime = new Date(item.create_time)

            this.time = timeFormat(TheEnglishTime); // 时间格式化  y-m-d h:m:s 
            this.timeTemp = parseInt(TheEnglishTime.getTime() / 1000); // 秒  
            this.timesTemp = TheEnglishTime.getTime(); // 毫秒 

            let create_time1 = this.timeTemp + 259200;

            let date = new Date(create_time1 * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d; //天补0
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s; //秒补0
            var aaaaa = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
            item.create_time1 = aaaaa



            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              total_price: item.total_price,
              order_source: item.order_source,
              order_source_text: item.order_source_text,
              is_top_row: true,
              order_status: item.order_status.value,
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },

    /*打开添加*/
   addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({ path: '/order/order/Detail', query: { order_id: params } });
      window.open(routeData.href, '_blank');
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      }
      // self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;

          self.openLogistics()
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    }
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒

    },



  },
};
</script>
<style lang="scss">
.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #FFA49F;
  padding: 5px;
  background-color: #FFF1F0;
  color: #F6363E;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/dhindex copy.vue